import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNewrelicComponent } from './simple-icons-newrelic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNewrelicComponent ],
    exports:      [ SimpleIconsNewrelicComponent ],
    bootstrap:    []
})
export class SimpleIconsNewrelicModule {}
